import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3160586431/src/actions-runner/_work/enterprise-apps/enterprise-apps/apps/pfdn/src/app/partners/PartnersClient.tsx");
